export const ADDRESS_SHOW_RESET = 'ADDRESS_SHOW_RESET'
export const ADDRESS_SHOW_SET_ERROR = 'ADDRESS_SHOW_SET_ERROR'
export const ADDRESS_SHOW_SET_RETRIEVED = 'ADDRESS_SHOW_SET_RETRIEVED'
export const ADDRESS_SHOW_TOGGLE_LOADING = 'ADDRESS_SHOW_TOGGLE_LOADING'
